export default defineNuxtRouteMiddleware(() => {
  const runtimeConfig = useRuntimeConfig().public;
  const isEnabledTeamsView = runtimeConfig.APP_CUSTOMER.enable_teams;

  if (!isEnabledTeamsView)
    showError({ statusCode: 404 });
});
